import "./MarketingConsentCheckbox.css";

// Required to register. Links open in a new tab so the half-filled form isn't lost.
const TermsConsentCheckbox = ({ checked, onChange, id = "termsConsent", className = "" }) => {
	return (
		<label htmlFor={id} className={`terms-consent ${className}`}>
			<input
				type="checkbox"
				id={id}
				checked={!!checked}
				onChange={(e) => onChange(e.target.checked)}
			/>
			<span>
				I agree to the{" "}
				<a href="/terms-and-conditions" target="_blank" rel="noopener noreferrer">Terms & Conditions</a>
				{" "}and{" "}
				<a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a> *
			</span>
		</label>
	);
};

export default TermsConsentCheckbox;
